/* eslint-disable @typescript-eslint/no-explicit-any */
import { parse } from 'svg-parser';

export const hasViewBox = async (file: File) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      const text = event.target?.result;
      if (!text || typeof text !== 'string') reject();

      const parsed = parse(text as string);
      const svg = parsed.children.find((child) => (child as any).tagName === 'svg') as any;

      if (!svg.properties.viewBox) return resolve(false);

      const parts = svg.properties.viewBox.split(' ');
      if (parts.length !== 4) return resolve(false);

      return resolve(true);
    };
    reader.onerror = (event) => {
      reject(event);
    };
    reader.readAsText(file);
  });
};
